module.exports = __webpack_public_path__ + "img/15.d95a47ba.png";